<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import DefaultLayout from './layouts/DefaultLayout.vue';

export default {
  name: "App",
  components: {
    DefaultLayout,
  },
  computed: {
    layout() {
      return "default-layout";
    },
  },
};
</script>

<style>
@import "../public/global/global.css";
@import "../public/assets/leaflet/MarkerCluster.css";
@import "../public/assets/leaflet/MarkerClusterDefault.css";
</style>